<template>
  <b-modal v-model="showModal" centered header-class="custom-modal-header" footer-class="custom-modal-footer">
    <template #modal-header>
      <p class="text-header">Select Page</p>
    </template>
    <div class="pt-3" v-if="pages.length > 0">
      <b-form-group class="mb-0">
        <b-form-radio
          v-model="selectedPage"
          v-for="(page, pageIndex) in pages"
          :key="pageIndex"
          name="page-fb"
          :value="page"
          class="mb-3 radio-page-fb"
        >
          <div class="d-flex">
            <div v-if="page.instagram_business_account" class="d-flex justify-content-between">
              <img :src="page.picture.data.url" width="40" class="mr-1" />
              <font-awesome-icon :icon="['fas', 'link']" />
              <img
                v-if="page.instagram_business_account"
                :src="page.instagram_business_account.profile_picture_url"
                width="40"
                class="mr-1"
              />
            </div>
            <img v-else :src="page.picture.data.url" width="80" class="mr-1" />
            <div class="align-middle">
              <span class="d-block">Facebook: {{ page.name }}</span>
              <span v-if="page.instagram_business_account"
                >Instagram: {{ page.instagram_business_account.username }}</span
              >
            </div>
          </div>
        </b-form-radio>
      </b-form-group>
    </div>
    <div v-else class="text-center py-3">
      <span>No Page</span>
    </div>
    <div class="mb-3" v-if="v && v.$error">
      <span class="text-danger" v-if="v.id.required == false">Please Select Page</span>
    </div>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <button :disabled="isLoading" class="cancel-button" @click="onCloseModal()">
          Cancel
        </button>
        <button :disabled="isLoading" class="save-button" @click="confirm(selectedPage)">
          Confrim
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "ModalSelectPageFacebook",
  data: function() {
    return {
      selectedPage: {
        url: null,
        name: "",
        access_token: "",
        picture: {
          data: {
            url: "",
            name: null,
            access_token: null,
            picture: null,
            id: null,
          },
        },
        id: "",
        instagram_business_account: {
          id: null,
          username: null,
          profile_picture_url: null,
        },
      },
      showModal: false,
      isLoading: false,
    };
  },
  props: {
    pages: {
      required: false,
      type: Array,
    },
    v: {
      required: false,
      type: Object,
    },
  },
  methods: {
    setDefaultData() {
      this.selectedPage = {
        url: null,
        name: "",
        access_token: "",
        picture: {
          data: {
            url: "",
            name: null,
            access_token: null,
            picture: null,
            id: null,
          },
        },
        id: "",
        instagram_business_account: {
          id: null,
          username: null,
          profile_picture_url: null,
        },
      };
    },
    onCloseModal() {
      this.showModal = false;
    },
    onShowModal() {
      this.setDefaultData();
      this.showModal = true;
    },
    async confirm(selectedPage) {
      this.$emit("handleSelectedPage", selectedPage);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .radio-page-fb {
  label {
    cursor: pointer;
  }
  > input[type="radio"],
  .custom-control-label::before,
  .custom-control-label::after {
    top: 16px;
  }
}
</style>
